// extracted by mini-css-extract-plugin
export default {"wrapper":"Table_wrapper__hCloC","table":"Table_table__txjg-","row":"Table_row__cHj42","col":"Table_col__7VC7E"};